import { Link } from 'react-router-dom';
import { realtimeTracking } from '@/mocks/home';

export default function CategoryTracking() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 border border-primary-300 text-primary-600 text-xs font-semibold rounded-full">
            实时更新
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mt-4">
            黑料分类
            <span className="block">实时追踪</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-lg mx-auto">
            按类别追踪你感兴趣的黑料，不错过任何一条劲爆内容
          </p>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {realtimeTracking.map((item) => (
            <li key={item.id}>
              <Link
                to="/category/all"
                className="group flex flex-col p-5 rounded-xl bg-background-50 border border-background-200/70 hover:bg-primary-50 transition-all duration-300 cursor-pointer h-full"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.count}条
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                  {item.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium mt-3 group-hover:gap-2 transition-all">
                  立即追踪
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}